import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon, BookOpenIcon, GiftIcon, DownloadIcon, LockIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { coverImage } from '../data/landing';
const trust = [{
  icon: BookOpenIcon,
  label: 'Ebook digital · 150 salmos'
}, {
  icon: GiftIcon,
  label: '3 bonos exclusivos'
}, {
  icon: DownloadIcon,
  label: 'Acceso inmediato'
}, {
  icon: LockIcon,
  label: 'Compra segura'
}];
export function Hero() {
  return <section className="relative overflow-hidden bg-cream" data-id="element-55" data-mp="xanpq20yvlgf">
      <div className="mx-auto grid max-w-6xl items-center gap-12 px-5 pb-16 pt-12 md:px-8 lg:grid-cols-[1.1fr_0.9fr] lg:gap-16 lg:pb-24 lg:pt-20" data-id="element-56" data-mp="xb5r1d2hkpv7">
        <div className="order-2 lg:order-1" data-id="element-57" data-mp="ncq31iyr9wpx">
          <h1 className="font-serif text-5xl font-semibold leading-[1.02] text-ink md:text-6xl lg:text-7xl" data-id="element-58" data-mp="nbyhl0yvhfdd">
            El Poder de <span className="italic text-gold" data-id="element-59" data-mp="3cz5vmcnsk20v">los Salmos</span>
          </h1>
          <p className="mt-6 max-w-xl text-lg leading-relaxed text-muted md:text-xl" data-id="element-60" data-mp="3814cxsua24px">
            Descubrí el mensaje profundo de los Salmos y fortalecé tu conexión con Dios, un día a la vez.
          </p>

          

          <div className="mt-9 flex flex-col items-start gap-4" data-id="element-61" data-mp="3o59bpicfn4e0">
            <CtaButton size="lg" data-id="element-62" data-mp="399tex5kgwudx">Sí, quiero descubrir el poder de los Salmos</CtaButton>
            <div className="flex items-center gap-2 text-sm text-muted" data-id="element-63" data-mp="3e84odf6up2vm">
              <span className="flex" aria-label="5 de 5 estrellas" data-id="element-64" data-mp="30hho3ilfz4xf">
                {Array.from({
                length: 5
              }).map((_, i) => <StarIcon key={i} className="h-4 w-4 fill-gold-bright text-gold-bright" aria-hidden="true" data-id="element-65" data-mp="35aat87ktofa1" data-mpi={i} />)}
              </span>
              Un recurso digital para acompañar tu camino de fe.
            </div>
          </div>

          <ul className="mt-10 grid grid-cols-2 gap-x-6 gap-y-3 border-t border-line pt-6 sm:grid-cols-4" data-id="element-66" data-mp="2vglk7513bis0">
            {trust.map(({
            icon: Icon,
            label
          }) => <li key={label} className="flex items-center gap-2 text-sm text-ink/80" data-id="element-67" data-mp="2ljz0wkoewzs3">
                <Icon className="h-4 w-4 shrink-0 text-gold" aria-hidden="true" data-id="element-68" data-mp="s3mbny4btqw9" />
                <span data-id="element-69" data-mp="na9yck53l6it">{label}</span>
              </li>)}
          </ul>
        </div>

        <motion.div className="order-1 lg:order-2" initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-70" data-mp="ibgmsx9dfpla">
          <div className="relative mx-auto max-w-sm lg:max-w-none" data-id="element-71" data-mp="1ayt8l57pjtdj">
            <img src={coverImage} alt="Portada del ebook El Poder de los Salmos en tu Vida" className="w-full rounded-2xl shadow-[0_30px_80px_-30px_rgba(43,33,24,0.45)]" data-id="element-72" data-mp="163472wc4o2el" />
            
          </div>
        </motion.div>
      </div>
    </section>;
}